<template>
  <FormSegmentedControl
    v-model="modelValue"
    :items="[
      {name: 'noMin', label: 'No min', ariaLabel: 'No minimum', value: null},
      {name: 'twos', label: '2v2', ariaLabel: 'Two-on-two', value: 4},
      {name: 'threes', label: '3v3', ariaLabel: 'Three-on-three', value: 6},
      {name: 'fours', label: '4v4', ariaLabel: 'Four-on-four', value: 8},
      {name: 'fives', label: '5v5', ariaLabel: 'Five-on-five', value: 10},
    ]"
  />
</template>

<script setup lang="ts">
import FormSegmentedControl from "./FormSegmentedControl.vue";

const modelValue = defineModel<number | null>({
  required: true,
});
</script>
